export const MARKET_BREIFING_HAS_READ_LATEST = 'mbHasRead';
export const MARKET_BRIEFING_LATEST_ARTICLE_ID = 'mbLatestArticleId';
